/**
 * Public image URL by folder and filename.
 * Images live under public/images/<folder>/<filename>.
 */
export const imageUrl = (folder, file) =>
  `${process.env.PUBLIC_URL || ""}/images/${folder}/${file}`;
